<template>
  <div>
    <populate-form
      formTitle="公休日申請管理"
      fkey="mm01"
      ref="filterStoreForm"
      populateOptionVar="filterOptions"
      formDataObjVar="filterData"
      :validatePrompt="false"
      :parentVue="this"
      @customValueChanged="filterChanged"
    ></populate-form>
    <b-table
      :items="restDays"
      :fields="fields"
    >
      <template v-slot:cell(pply_date)="row">
        {{row.item.apply_start}}{{row.item.apply_start===row.item.apply_end?'':('~'+row.item.apply_end)}}
      </template>
      <template v-slot:cell(status)="row">
        {{row.item.status=='valid'?'生效中':(row.item.status=='wait_approve'?'申請中':'已取消')}}
      </template>
      <template v-slot:cell(cause_reply)="row">
        {{row.item.custom_cause}}{{row.item.approve_remark?(' 回覆：'+row.item.approve_remark):''}}
      </template>
      <template v-slot:cell(actions)="row">
        <b-button v-if="filterData.status==='wait_approve'" class="ml-1" @click.stop="cancalApply(row.item,0)">取消申請</b-button>
      </template>
    </b-table>
    <b-modal
      id="applyRestModal"
      ref="addApplyModal"
      v-model="modalAddShow" 
      centered
      hide-header
      hide-footer
      :static="true"
    >
      <populate-form
        formTitle="申請休息日"
        fkey="cr01"
        ref="applyForm"
        populateOptionVar="applyOptions"
        :parentVue="this"
        formDataObjVar="applyData"
      />
    </b-modal>
  </div>
</template>

<script>


export default {
  name: 'StoreRestDayApply',
  components: {

  },
  data: function () {
    return {
      modalAddShow:false,
      applyData:{},
      applyOptions:[
        {
          componentType:'date-picker',
          akey:'apply_start_date',
          col:6,
          placeholder:'休息日申請-起',
          defaultValue:''
        },
        {
          componentType:'date-picker',
          akey:'apply_end_date',
          col:6,
          placeholder:'迄(不填則同一天)',
          defaultValue:''
        },
        {
          componentType:'text',
          akey:'custom_cause',
          col:12,
          defaultValue:'',
          placeholder:'輸入例外休息日申請理由'
        },
        {
          componentType:'btn-group',
          col:12,
          buttons:[
            {
              col:1
            },
            {
              col:3,
              placeholder:'取消',
              execCallback:()=>{this.modalAddShow=false}
            },
            {
              col:3
            },
            {
              col:3,
              placeholder:'確認',
              execCallback:this.applyNewRestDay

            },
            {
              col:3
            }
          ]
        }
        
      ],
      restDays:[],
      fields:[
        {
          key:'apply_date',
          label:'公休日'
        },
        {
          key:'status',
          label:'狀態'
        },
        {
          key:'cause_reply',
          label:"理由-回應"
        },
        {
          key:"actions",
          label:'操作'
        }
      ],
      filterData: {},
      filterOptions:[
        {
          componentType:'date-picker',
          akey:'filter_date_s',
          col:2,
          placeholder:"篩選公休日-起",
        },
        {
          componentType:'date-picker',
          akey:'filter_date_e',
          col:2,
          placeholder:"篩選公休日-迄",
        },
        {
          componentType:'b-form-select',
          akey:'status',
          col:2,
          defaultValue:'wait_approve',
          dataOptions:[{text:'申請中',value:'wait_approve'},{text:'生效中',value:'valid'},{text:'取消紀錄',value:'dropped'}],
        },
        {
          componentType:'b-button',
          col:2,
          placeholder:"查詢",
          execCallback:this.getStoreRestDays
        },
        {
          componentType:'span',
          col:2
        },
        {
          componentType:'b-button',
          col:2,
          placeholder:"新申請",
          execCallback:this.showAdd
        }
      ],
      store_id:0,
    }
  },
  methods: {
    showAdd() {
      this.modalAddShow = true
    },
    applyNewRestDay() {
      if (!this.applyData.apply_start_date) {
        this.$refs.applyForm.triggerAlert("申請日期(起)未填寫")
        return
      }
      else {
        if (this.applyData.apply_start_date < this.getDateByStr('',0,'-')) {
          this.$refs.applyForm.triggerAlert("請不要申請已過期的休息日")
          return
        }
        if (this.applyData.apply_end_date && this.applyData.apply_end_date < this.applyData.apply_start_date) {
          this.$refs.applyForm.triggerAlert("申請起迄日期有誤")
          return
        }
      }
      if (!this.applyData.custom_cause) {
        this.$refs.applyForm.triggerAlert("請至少填寫一個字的理由")
        return
      }
      
      if (!this.applyData.apply_end_date) {
        this.applyData.apply_end_date = this.applyData.apply_start_date
      }

      let Param = {
        module:'store',
        method:'applyCustomRestDay',
        store_id:this.store_id,
        apply_start_date:this.applyData.apply_start_date,
        apply_end_date:this.applyData.apply_end_date,
        custom_cause:this.applyData.custom_cause
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
          vm.$refs.applyForm.triggerAlert("申請成功")
          vm.getStoreRestDays()
          setTimeout(() => {
            vm.modalAddShow = false
          }, 1000);
      },this)
    },
    cancalApply(item) {
      this.$bus.fnShowConfirm("確認要取消申請嗎？", ()=> {
        let Param = {
          module:'store',
          method:'cancelCustomRestDayApply',
          apply_ids:item.ids,
        }
        this.$bus.apiCall(Param, function (data, vm) {
          if (data.ok === 0) {
              vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
              return
            }
            vm.$bus.fnClosePopup()
            vm.$bus.fnShowInfo("已取消")
            vm.getStoreRestDays()
        },this)
      })
    },
    filterChanged(upd) {
      // 避免upd沒用到而已= =
      if (upd.key) {
          this.getStoreRestDays()
      }
    },
    getStoreRestDays() {
      //新增或保存一個店家的劃位設定
      let Param = {
        module:'store',
        method:'getStoreRestDays',
        filter_date_s:this.filterData.filter_date_s?this.filterData.filter_date_s:'',
        filter_date_e:this.filterData.filter_date_e?this.filterData.filter_date_e:'',
        status:this.filterData.status,
        store_id:this.store_id
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
          vm.restDays = data.data
      },this)
    },
  },
  computed:{
    
  },
  created () {
    if (!this.$bus.session) {
      this.$bus.session = undefined
    }
  },
  mounted () {
    // 未初始化時預設值會是undefined,需注意呼叫api的參數處理
    if (!this.$bus.session.merchant_store_id) {
      this.$bus.session = null
    }
    this.store_id = this.$bus.session.merchant_store_id
    this.$refs.filterStoreForm.initDefault()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
